import { render, staticRenderFns } from "./add_submission.vue?vue&type=template&id=a0191608&scoped=true&"
import script from "./add_submission.vue?vue&type=script&lang=js&"
export * from "./add_submission.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./add_submission.vue?vue&type=style&index=1&id=a0191608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0191608",
  null
  
)

export default component.exports